import React from "react";
import {
  formatTime,
  isToday,
} from "../../../utils/helperFunctions";
import { StockIcon } from "../../StockIcon/StockIcon";
import "./orderItemMobile.scss";
import {
  API_VS_UI_PRODUCT_TYPES_MAPPING,
  ORDER_STATUS_CLASSNAMES,
  ORDER_STATUS_TO_UI_MAPPING,
  getPurchaseText,
} from "./orders.constants";

const OrderItemMobile = ({ order, onClick = () => {} }) => {
  const isPartialOrder = order => {
    return (
      order.filledQuantity > 0 &&
      order.filledQuantity < order.quantity
    );
  };
  return (
    <div
      className="orderItemContainer"
      onClick={() => onClick?.()}
    >
      <StockIcon
        ppRefId={order?.instrumentDetails?.ppRefId}
      />
      <div className="orderDetailContainer">
        <div className="scripName">
          {order.instrumentDetails.name}
        </div>
        <div className="orderDetail">
          {order.transactionType +
            " " +
            order.quantity +
            " @ " +
            getPurchaseText(
              order?.orderType,
              order?.priceType,
              order?.limitPrice,
              order?.triggerPrice?.value
            )}
        </div>
        <div className="orderType">
          {
            API_VS_UI_PRODUCT_TYPES_MAPPING[
              order.productType
            ]
          }
        </div>
      </div>
      <div className="orderStatusContainer">
        <div
          className={`status ${
            isPartialOrder(order)
              ? "pending"
              : ORDER_STATUS_CLASSNAMES[
                  ORDER_STATUS_TO_UI_MAPPING[
                    order.orderStatus
                  ]
                ]
          }`}
        >
          {isPartialOrder(order)
            ? `PARTIAL (${order.filledQuantity} / ${order.quantity})`
            : ORDER_STATUS_TO_UI_MAPPING[order.orderStatus]}
        </div>
        {!isToday(order.createdAt) && (
          <div className="dateFormat">
            {formatTime(order.createdAt, "DD MMM")}
          </div>
        )}
        <div className="dateFormat">
          {formatTime(order.createdAt)}
        </div>
      </div>
    </div>
  );
};

export default OrderItemMobile;
